import {APIDirectory , HTTP} from '../../rest'
import { constant } from "./TeacherActionsConstants";

export const saveTeacherInProgress = () => {
    return{
    type:constant.SAVE_TEACHER_IN_PROGRESS
}}

export const saveTeacherComplete =(data) => {
    return{
        type:constant.SAVE_TEACHER_COMPLETE,
        data:data
    }
}

export const saveTeacher = (school)=>
{  
    return async dispatch => {
        try{
            dispatch(saveTeacherInProgress());
            let url = APIDirectory.getUpdateSchoolURL(12,school._id);
            let updatedschool = await HTTP.PUT(url ,JSON.stringify(school));
            dispatch(saveTeacherComplete(updatedschool));
            return updatedschool;
        }
        catch(error){
            return[];
        }

    }
}





